



















































import { Component, Vue } from 'vue-property-decorator';
import TicketCondition from '@/components/home/TicketCondition.vue';
import MemberIconList from '@/components/common/MemberIconList.vue';
import TicketChartCard from '@/components/home/TicketChartCard.vue';
import ApplicantListCard from '@/components/home/ApplicantListCard.vue';
import ActivityListCard from '@/components/common/ActivityListCard.vue';
import ApplicantListDialog from '@/components/home/ApplicantListDialog.vue';
import OperationMemberList from '@/components/home/OperationMemberList.vue';
import ProjectInfo from '@/components/home/ProjectInfo.vue';
import ProjectInfoSkeletonLoader from '@/components/home/ProjectInfoSkeletonLoader.vue';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { vxm } from '@/store';
import { Account } from '@/@types/Account';

@Component({
  components: {
    MemberIconList,
    TicketChartCard,
    ApplicantListCard,
    ActivityListCard,
    ApplicantListDialog,
    OperationMemberList,
    OrganizationIcon,
    ProjectInfo,
    ProjectInfoSkeletonLoader,
    TicketCondition,
  },
})
export default class Home extends Vue {
  private isProjectLoading: boolean = true;
  private isProjectMemberLoading: boolean = true;
  private isActivityLoading: boolean = true;
  private async created() {
    if (this.projectId) {
      await this.fetchProjectById(this.projectId);
      await this.fetchProjectMembersById(this.projectId);
      await this.fetchActivitiesById(this.projectId);

      if (this.project) {
        this.isProjectLoading = false;
      }

      if (this.projectMembers.length !== 0) {
        this.isProjectMemberLoading = false;
      }

      this.isActivityLoading = false;
    }
  }

  private async fetchProjectById(projectId: number) {
    return await vxm.theoryApi.projectsStore.fetchProjectBasic(projectId);
  }

  private async fetchProjectMembersById(projectId: number) {
    return await vxm.theoryApi.projectMembersStore.fetchProjectMembersById(projectId);
  }

  /**カレントプロジェクトのアクティビティのみを取得 */
  private async fetchActivitiesById(projectId: number) {
    return await vxm.theoryApi.activitiesStore.fetchProjectActivities({
      projectIds: this.projectId ? [this.projectId] : [],
      organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number });
  }

  private get project() {
    const response = vxm.theoryApi.projectsStore.getProjectBasic;
    return response;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get isProjectLoadingNow() {
    return this.isProjectLoading;
  }

  private get projectMembers() {
    const response = vxm.theoryApi.projectMembersStore.getHomeProjectMembers;
    if (response) {
      return response.results;
    } else return [];
  }
  private get activities() {
    const response = vxm.theoryApi.activitiesStore.getProjectActivities;
    if (response) {
      return response.results;
    } else return [];
  }
}
